import { useKeycloak } from "@react-keycloak/web";
import { Redirect, Route, RouteProps } from "react-router";

export type ProtectedRouteProps = {
    authenticationPath: string;
} & RouteProps;

export default function ProtectedRoute({
    authenticationPath,
    ...routeProps
}: ProtectedRouteProps) {
    const { keycloak } = useKeycloak();

    if (keycloak.authenticated) {
        return <Route {...routeProps} />;
    }
    return <Redirect to={{ pathname: "/login" }} />;
}
